__turbopack_context__.v({
  "imgOverlay": "styles-module__T3LhGq__imgOverlay",
  "link": "styles-module__T3LhGq__link",
  "tileContainer": "styles-module__T3LhGq__tileContainer",
  "tileLayout": "styles-module__T3LhGq__tileLayout",
  "title": "styles-module__T3LhGq__title",
});
